import { gql } from '@apollo/client';

export const GET_INTEGRATIONS = gql`
  query GetIntegrations {
    getIntegrations
  }
`;

export type GetIntegrationsData = {
  getIntegrations: string[];
};
